<template>
  <v-card class="rounded-sm" color="primary">
    <v-card-text>
      <v-container>
        <v-form v-model="form" ref="form">
          <v-row>
            <v-col cols="12">
              <div class="text-h6 mb-2">Información General</div>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                v-model="convocatoria.convocatoria"
                label="Nombre de convocatoria"
                :rules="required"
                rounded
                filled
                dense
                color="secondary"
                background-color="primary"
              >
                <template v-slot:label>Nombre de convocatoria <span class="red--text">*</span></template>
              </v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <v-select
                v-model="convocatoria.fk_idDirigidaA"
                :items="dirigidos"
                item-value="id"
                item-text="title"
                :rules="required"
                rounded
                filled
                dense
                color="secondary"
                background-color="primary"
              >
                <template v-slot:label>Dirigida a <span class="red--text">*</span></template>
              </v-select>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12">
              <div class="text-h6 mb-2 mt-4">Clasificación</div>
            </v-col>
            <v-col cols="12" md="4">
              <v-select
                v-model="convocatoria.fk_idTipoConvocatoria"
                :items="tiposConvocatoria"
                item-value="id"
                item-text="title"
                :rules="required"
                rounded
                filled
                dense
                color="secondary"
                background-color="primary"
              >
                <template v-slot:label>Tipo de convocatoria <span class="red--text">*</span></template>
              </v-select>
            </v-col>
            <v-col cols="12" md="4">
              <v-select
                v-model="convocatoria.fk_idSubTipoConvocatoria"
                :items="subtiposConvocatoria"
                item-value="id"
                item-text="title"
                :rules="required"
                :disabled="!convocatoria.fk_idTipoConvocatoria"
                rounded
                filled
                dense
                color="secondary"
                background-color="primary"
              >
                <template v-slot:label>Subtipo de convocatoria <span class="red--text">*</span></template>
              </v-select>
            </v-col>
            <v-col cols="12" md="4">
              <v-select
                v-model="convocatoria.fk_idGradoPromocion"
                :items="gradosPromocion"
                item-value="id"
                item-text="title"
                rounded
                filled
                dense
                color="secondary"
                background-color="primary"
              >
                <template v-slot:label>Grado a promocionar</template>
              </v-select>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12">
              <div class="text-h6 mb-2 mt-4">Requisitos y Beneficios</div>
            </v-col>
            <v-col cols="3">
              <v-textarea
                v-model="convocatoria.requisitos"
                :rules="required"
                rounded
                filled
                dense
                color="secondary"
                background-color="primary"
                no-resize
                rows="5"
              >
                <template v-slot:label>Requisitos <span class="red--text">*</span></template>
              </v-textarea>
            </v-col>
            <v-col cols="3">
              <v-textarea
                v-model="convocatoria.beneficios"
                :rules="required"
                rounded
                filled
                dense
                color="secondary"
                background-color="primary"
                no-resize
                rows="5"
              >
                <template v-slot:label>Beneficios <span class="red--text">*</span></template>
              </v-textarea>
            </v-col>
            <v-col cols="3">
              <v-textarea
                v-model="convocatoria.plazasVacantes"
                :rules="required"
                rounded
                filled
                dense
                color="secondary"
                background-color="primary"
                no-resize
                rows="5"
              >
                <template v-slot:label>Plazas vacantes <span class="red--text">*</span></template>
              </v-textarea>
            </v-col>
            <v-col cols="3">
              <v-textarea
                v-model="convocatoria.documentacion"
                rounded
                filled
                dense
                color="secondary"
                background-color="primary"
                no-resize
                rows="5"
              >
                <template v-slot:label>Documentación<span class="red--text">*</span></template>
              </v-textarea>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12">
              <div class="text-h6 mb-2 mt-4">Proceso de Selección</div>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                v-model="convocatoria.procedimientoSeleccion"
                label="Procedimiento de selección"
                rounded
                filled
                dense
                color="secondary"
                background-color="primary"
              />
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                v-model="convocatoria.lugarRecepcionDocumentos"
                label="Lugar de recepción de documentación"
                rounded
                filled
                dense
                color="secondary"
                background-color="primary"
              />
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12">
              <div class="text-h6 mb-2 mt-4">Fechas Importantes</div>
            </v-col>
            <v-col cols="4">
              <v-menu
                v-model="menuFechaPublicacion"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    :value="fechaPublicacionFormatted"
                    append-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    rounded
                    filled
                    dense
                    color="secondary"
                    background-color="primary"
                    hint="Formato: DD/MM/YYYY HH:mm:ss"
                    :rules="required"
                  >
                    <template v-slot:label>Fecha de publicación <span class="red--text">*</span></template>
                  </v-text-field>
                </template>
                <v-date-picker
                  v-model="convocatoria.fechaHoraPublicacionConvocatoria"
                  @input="menuFechaPublicacion = false"
                  locale="es"
                  no-title
                />
              </v-menu>
            </v-col>
            <v-col cols="4">
              <v-menu
                v-model="menuFechaRecepcion"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    :value="fechaRecepcionFormatted"
                    append-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    rounded
                    filled
                    dense
                    color="secondary"
                    background-color="primary"
                    hint="Formato: DD/MM/YYYY HH:mm:ss"
                    :rules="required"
                  >
                    <template v-slot:label>Recepción documentos <span class="red--text">*</span></template>
                  </v-text-field>
                </template>
                <v-date-picker
                  v-model="convocatoria.fechaHoraRecepcionDocumentos"
                  @input="menuFechaRecepcion = false"
                  locale="es"
                  no-title
                />
              </v-menu>
            </v-col>
            <v-col cols="4">
              <v-menu
                v-model="menuFechaInicio"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    :value="fechaInicioFormatted"
                    append-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    rounded
                    filled
                    dense
                    color="secondary"
                    background-color="primary"
                    hint="Formato: DD/MM/YYYY HH:mm:ss"
                    :rules="required"
                  >
                    <template v-slot:label>Fecha inicio registro <span class="red--text">*</span></template>
                  </v-text-field>
                </template>
                <v-date-picker
                  v-model="convocatoria.fechaHoraInicioRegistro"
                  @input="menuFechaInicio = false"
                  locale="es"
                  no-title
                />
              </v-menu>
            </v-col>
            <v-col cols="6">
              <v-menu
                v-model="menuFechaCierre"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    :value="fechaCierreFormatted"
                    append-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    rounded
                    filled
                    dense
                    color="secondary"
                    background-color="primary"
                    hint="Formato: DD/MM/YYYY HH:mm:ss"
                    :rules="required"
                  >
                    <template v-slot:label>Fecha cierre registro <span class="red--text">*</span></template>
                  </v-text-field>
                </template>
                <v-date-picker
                  v-model="convocatoria.fechaHoraCierreRegistro"
                  @input="menuFechaCierre = false"
                  locale="es"
                  no-title
                />
              </v-menu>
            </v-col>
            <v-col cols="6">
              <v-menu
                v-model="menuFechaResultados"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    :value="fechaResultadosFormatted"
                    append-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    rounded
                    filled
                    dense
                    color="secondary"
                    background-color="primary"
                    hint="Formato: DD/MM/YYYY HH:mm:ss"
                    :rules="required"
                  >
                    <template v-slot:label>Fecha de resultados <span class="red--text">*</span></template>
                  </v-text-field>
                </template>
                <v-date-picker
                  v-model="convocatoria.fechaHoraResultados"
                  @input="menuFechaResultados = false"
                  locale="es"
                  no-title
                />
              </v-menu>
            </v-col>
          </v-row>
        </v-form>
      </v-container>
    </v-card-text>
    <v-card-actions class="justify-center py-4">
      <TextButton color="secondary" :loading="loading" :disabled="!validForm || loading" @click="editarConvocatoria">
        Actualizar Convocatoria
      </TextButton>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import moment from 'moment'
import TextButton from '@/components/base/TextButton.vue'

export default {
  components: { TextButton },

  props: {
    convocatoriaData: {
      type: Object,
      default: null,
    },
  },

  data() {
    return {
      form: false,
      loading: false,
      menuFechaPublicacion: false,
      menuFechaRecepcion: false,
      menuFechaInicio: false,
      menuFechaCierre: false,
      menuFechaResultados: false,
      convocatoria: {
        id: null,
        fk_idTipoConvocatoria: null,
        fk_idSubTipoConvocatoria: null,
        fk_idGradoPromocion: null,
        fk_idDirigidaA: null,
        convocatoria: '',
        beneficios: '',
        plazasVacantes: '',
        requisitos: '',
        documentacion: '',
        lugarRecepcionDocumentos: '',
        procedimientoSeleccion: '',
        fechaHoraRecepcionDocumentos: '',
        fechaHoraPublicacionConvocatoria: '',
        fechaHoraInicioRegistro: '',
        fechaHoraCierreRegistro: '',
        fechaHoraResultados: '',
      },
      required: [(v) => !!v || 'Este campo es requerido.'],
    }
  },

  async created() {
    await this.loadCatalogos()
    await this.cargarDatosConvocatoria()
  },

  computed: {
    ...mapGetters('convocatorias', {
      tiposConvocatoria: 'getTiposConvocatoria',
      subtiposConvocatoria: 'getSubtiposConvocatoria',
      gradosPromocion: 'getGradosPromocion',
      dirigidos: 'getDirigidos',
    }),
    validForm() {
      return (
        this.form &&
        this.convocatoria.fechaHoraRecepcionDocumentos &&
        this.convocatoria.fechaHoraPublicacionConvocatoria &&
        this.convocatoria.fechaHoraInicioRegistro &&
        this.convocatoria.fechaHoraCierreRegistro &&
        this.convocatoria.fechaHoraResultados
      )
    },
    fechaPublicacionFormatted() {
      return this.convocatoria.fechaHoraPublicacionConvocatoria
        ? moment(this.convocatoria.fechaHoraPublicacionConvocatoria, 'YYYY-MM-DD').format('DD/MM/YYYY')
        : ''
    },
    fechaRecepcionFormatted() {
      return this.convocatoria.fechaHoraRecepcionDocumentos
        ? moment(this.convocatoria.fechaHoraRecepcionDocumentos, 'YYYY-MM-DD').format('DD/MM/YYYY')
        : ''
    },
    fechaInicioFormatted() {
      return this.convocatoria.fechaHoraInicioRegistro
        ? moment(this.convocatoria.fechaHoraInicioRegistro, 'YYYY-MM-DD').format('DD/MM/YYYY')
        : ''
    },
    fechaCierreFormatted() {
      return this.convocatoria.fechaHoraCierreRegistro
        ? moment(this.convocatoria.fechaHoraCierreRegistro, 'YYYY-MM-DD').format('DD/MM/YYYY')
        : ''
    },
    fechaResultadosFormatted() {
      return this.convocatoria.fechaHoraResultados
        ? moment(this.convocatoria.fechaHoraResultados, 'YYYY-MM-DD').format('DD/MM/YYYY')
        : ''
    },
  },

  methods: {
    ...mapActions('convocatorias', [
      'updateConvocatoria',
      'fetchAllTiposConvocatoria',
      'fetchSubtiposConvocatoriaByTipo',
      'fetchAllGradosPromocion',
      'fetchAllDirigidos',
      'fetchAllConvocatorias',
    ]),

    async loadCatalogos() {
      try {
        await Promise.all([this.fetchAllTiposConvocatoria(), this.fetchAllGradosPromocion(), this.fetchAllDirigidos()])
      } catch (error) {
        this.$store.commit('SET_SNACKBAR_MESSAGE', 'Error al cargar los catálogos')
      }
    },

    parseFechaFromAPI(fecha) {
      if (!fecha) return ''

      if (typeof fecha === 'string' && (fecha.includes('a. m.') || fecha.includes('p. m.'))) {
        const datePart = fecha.split(' ')[0]
        return moment(datePart, 'DD/MM/YYYY').format('YYYY-MM-DD')
      }

      return moment(fecha).format('YYYY-MM-DD')
    },

    parseId(value) {
      if (value === null || value === undefined || value === '') return null
      const parsed = parseInt(value, 10)
      return isNaN(parsed) ? value : parsed
    },

    async cargarDatosConvocatoria() {
      if (!this.convocatoriaData) {
        console.warn('No hay datos de convocatoria para cargar')
        return
      }

      try {
        const fk_idTipoConvocatoria = this.convocatoriaData.catSubTipoConvocatoria?.fk_idTipoConvocatoria || null

        this.convocatoria.fk_idTipoConvocatoria = this.parseId(fk_idTipoConvocatoria)

        if (fk_idTipoConvocatoria) {
          await this.fetchSubtiposConvocatoriaByTipo(fk_idTipoConvocatoria)
          await this.$nextTick()
        }

        this.convocatoria = {
          ...this.convocatoria,
          id: this.parseId(this.convocatoriaData.id),
          fk_idSubTipoConvocatoria: this.parseId(this.convocatoriaData.fk_idSubTipoConvocatoria),
          fk_idGradoPromocion: this.parseId(this.convocatoriaData.fk_idGradoPromocion),
          fk_idDirigidaA: this.parseId(this.convocatoriaData.fk_idDirigidaA),
          convocatoria: this.convocatoriaData.convocatoria || '',
          beneficios: this.convocatoriaData.beneficios || '',
          plazasVacantes: this.convocatoriaData.plazasVacantes || '',
          requisitos: this.convocatoriaData.requisitos || '',
          documentacion: this.convocatoriaData.documentacion || '',
          lugarRecepcionDocumentos: this.convocatoriaData.lugarRecepcionDocumentos || '',
          procedimientoSeleccion: this.convocatoriaData.procedimientoSeleccion || '',
          fechaHoraRecepcionDocumentos: this.parseFechaFromAPI(this.convocatoriaData.fechaHoraRecepcionDocumentos),
          fechaHoraPublicacionConvocatoria: this.parseFechaFromAPI(
            this.convocatoriaData.fechaHoraPublicacionConvocatoria
          ),
          fechaHoraInicioRegistro: this.parseFechaFromAPI(this.convocatoriaData.fechaHoraInicioRegistro),
          fechaHoraCierreRegistro: this.parseFechaFromAPI(this.convocatoriaData.fechaHoraCierreRegistro),
          fechaHoraResultados: this.parseFechaFromAPI(this.convocatoriaData.fechaHoraResultados),
        }
      } catch (error) {
        this.$store.commit('SET_SNACKBAR_MESSAGE', 'Error al cargar los datos de la convocatoria')
      }
    },

    async editarConvocatoria() {
      if (!this.$refs.form.validate()) {
        this.$store.commit('SET_SNACKBAR_MESSAGE', 'Por favor completa todos los campos requeridos')
        return
      }

      this.loading = true
      try {
        const payload = {
          fk_idSubTipoConvocatoria: this.convocatoria.fk_idSubTipoConvocatoria,
          fk_idGradoPromocion: this.convocatoria.fk_idGradoPromocion,
          fk_idDirigidaA: this.convocatoria.fk_idDirigidaA,
          convocatoria: this.convocatoria.convocatoria,
          beneficios: this.convocatoria.beneficios,
          plazasVacantes: this.convocatoria.plazasVacantes,
          requisitos: this.convocatoria.requisitos,
          documentacion: this.convocatoria.documentacion,
          lugarRecepcionDocumentos: this.convocatoria.lugarRecepcionDocumentos,
          procedimientoSeleccion: this.convocatoria.procedimientoSeleccion,
          fechaHoraPublicacionConvocatoria: this.convocatoria.fechaHoraPublicacionConvocatoria
            ? moment(this.convocatoria.fechaHoraPublicacionConvocatoria, 'YYYY-MM-DD').format('YYYY-MM-DD 00:00:00')
            : '',
          fechaHoraRecepcionDocumentos: this.convocatoria.fechaHoraRecepcionDocumentos
            ? moment(this.convocatoria.fechaHoraRecepcionDocumentos, 'YYYY-MM-DD').format('YYYY-MM-DD 00:00:00')
            : '',
          fechaHoraInicioRegistro: this.convocatoria.fechaHoraInicioRegistro
            ? moment(this.convocatoria.fechaHoraInicioRegistro, 'YYYY-MM-DD').format('YYYY-MM-DD 00:00:00')
            : '',
          fechaHoraCierreRegistro: this.convocatoria.fechaHoraCierreRegistro
            ? moment(this.convocatoria.fechaHoraCierreRegistro, 'YYYY-MM-DD').format('YYYY-MM-DD 00:00:00')
            : '',
          fechaHoraResultados: this.convocatoria.fechaHoraResultados
            ? moment(this.convocatoria.fechaHoraResultados, 'YYYY-MM-DD').format('YYYY-MM-DD 00:00:00')
            : '',
        }

        await this.updateConvocatoria({
          idConvocatoria: this.convocatoria.id,
          payload,
        })

        this.$store.commit('SET_SNACKBAR_MESSAGE', 'Convocatoria actualizada correctamente')
        await this.fetchAllConvocatorias()
        this.$emit('close')
      } catch (error) {
        this.$store.commit('SET_SNACKBAR_MESSAGE', 'Error al actualizar la convocatoria')
      } finally {
        this.loading = false
      }
    },
  },

  watch: {
    'convocatoria.fk_idTipoConvocatoria': {
      async handler(newVal, oldVal) {
        if (newVal && oldVal !== undefined && newVal !== oldVal) {
          this.convocatoria.fk_idSubTipoConvocatoria = null
          try {
            await this.fetchSubtiposConvocatoriaByTipo(newVal)
          } catch (error) {
            this.$store.commit('SET_SNACKBAR_MESSAGE', 'Error al cargar los subtipos')
          }
        }
      },
    },

    convocatoriaData: {
      handler() {
        this.cargarDatosConvocatoria()
      },
      deep: true,
    },
  },
}
</script>
